export default "__VITE_ASSET__CLKySJHH__"